import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/Home'
import Process from '@/components/Process/Process'
import baomingxuzhi from '@/components/baomingxuzhi/baomingxuzhi'
import wangshangdiaocha from '@/components/wangshangdiaocha/wangshangdiaocha'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/process',
      name: 'Process',
      component: Process
    },
    {
      path: '/baomingxuzhi',
      name: 'baomingxuzhi',
      component: baomingxuzhi
    },
    {
      path: '/wangshangdiaocha',
      name: 'wangshangdiaocha',
      component: wangshangdiaocha
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js